import { ValueOf } from '~types/common';

import { MENU_TYPE_OBJ } from '../constants';
import { LNB_LIST } from './constants';

export const getSelectedkMenu = (menuType: ValueOf<typeof MENU_TYPE_OBJ> | undefined) => {
  if (!menuType) return;

  return LNB_LIST.find((lnb) => lnb.id === menuType);
};
